import { Util } from "../../utils";
import { AgValueSetter, AgAutoCompleteEditor, AgNumericEditor, AgCheckboxComponent } from "app/components";

declare var moment: any;

export class GridFareIncidConfig {
  constructor(private pageComp: any) {
  }

  colDefFclIncid = [
    { headerName: '오픈상태',
      field: 'activityYn',
      editable: false,
      cellRenderer: 'activityYnRenderer',
      width: 100
    },
    { headerName: '포트', field: 'location',
      cellEditor: "locationEditor",
      editable : params => !params.data.isDel,
      valueGetter: params => params.data.location && params.data.location.locationCd ? '[' + params.data.location.locationCd + '] ' + params.data.location.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.selectedCountry)};},
      filter: "agTextColumnFilter",
      width: 160,
    },
    {
      headerName: '운임항목', field: 'item',
      cellEditor: "costItemEditor",
      editable: false,
      valueGetter: params => params.data.item && params.data.item.itemCd ? '[' + params.data.item.itemCd + '] ' + params.data.item.itemNm : '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.costItems, 'itemCd'),
      cellEditorParams: (param) => {return {items: this.pageComp.costItemAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 250
    },
    { 
      headerName: '통화',
      field: 'crncyCd',
      editable: false,
      cellEditor: "crncyEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.currencyAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 100
    },
    { headerName: '출발지',
      children: [
        {
          headerName: '20', 
          field: 'orgCntr20Cost',
          width: 100,
          editable: false,
          cellEditor: "orgCntr20CostEditor",
          cellRenderer: params => Util.numberFormat(params.value),
        },
        {
          headerName: '40', 
          field: 'orgCntr40Cost',
          width: 100,
          editable: false,
          cellEditor: "orgCntr40CostEditor",
          cellRenderer: params => Util.numberFormat(params.value),
        },
        {
          headerName: '40H',
          field: 'orgCntrHcCost',
          width: 100,
          editable: false,
          cellEditor: "orgCntrHcCostEditor",
          cellRenderer: params => Util.numberFormat(params.value),
        },
        {
          headerName: 'B/L',
          field: 'orgBlCost',
          width: 100,
          editable: false,
          cellEditor: "orgBlCostEditor",
          cellRenderer: params => Util.numberFormat(params.value),
        }
      ]
    },
    { headerName: '도착지',
      children: [
        {
          headerName: '20', 
          field: 'desCntr20Cost',
          width: 100,
          editable: false,
          cellEditor: "desCntr20CostEditor",
          cellRenderer: params => Util.numberFormat(params.value),
        },
        {
          headerName: '40', 
          field: 'desCntr40Cost',
          width: 100,
          editable: false,
          cellEditor: "desCntr40CostEditor",
          cellRenderer: params => Util.numberFormat(params.value),
        },
        {
          headerName: '40H',
          field: 'desCntrHcCost',
          width: 100,
          editable: false,
          cellEditor: "desCntrHcCostEditor",
          cellRenderer: params => Util.numberFormat(params.value),
        },
        {
          headerName: 'B/L',
          field: 'desBlCost',
          width: 100,
          editable: false,
          cellEditor: "desBlCostEditor",
          cellRenderer: params => Util.numberFormat(params.value),
        }
      ]
    },
    {
      headerName: '저장일시',
      field: 'orgInsDtm',
      editable: false,
      valueGetter: params => params.data.orgInsDtm ? params.data.orgInsDtm : params.data.desInsDtm,
      cellRenderer: params => {
        var date = Util.dateFomatter(params.value);
        return date;
      },
      width: 200
    }
  ];

  frameworkCompsFclIncid = {
    locationEditor: AgAutoCompleteEditor,
    costItemEditor: AgAutoCompleteEditor,
    crncyEditor: AgAutoCompleteEditor,
    orgCntr20CostEditor: AgNumericEditor,
    orgCntr40CostEditor: AgNumericEditor,
    orgCntrHcCostEditor: AgNumericEditor,
    orgBlCostEditor: AgNumericEditor,
    desCntr20CostEditor: AgNumericEditor,
    desCntr40CostEditor: AgNumericEditor,
    desCntrHcCostEditor: AgNumericEditor,
    desBlCostEditor: AgNumericEditor,
    activityYnRenderer : AgCheckboxComponent,
  };

  colDefLclIncid = [
    { headerName: '오픈상태',
      field: 'activityYn',
      editable: false,
      cellRenderer: 'activityYnRenderer',
      width: 100
    },
    { headerName: '포트', field: 'location',
      cellEditor: "locationEditor",
      editable: false,
      valueGetter: params => params.data.location && params.data.location.locationCd ? '[' + params.data.location.locationCd + '] ' + params.data.location.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.selectedCountry)};},
      filter: "agTextColumnFilter",
      width: 160,
    },
    {
      headerName: '운임항목', field: 'item',
      cellEditor: "costItemEditor",
      editable: false,
      valueGetter: params => params.data.item && params.data.item.itemCd ? '[' + params.data.item.itemCd + '] ' + params.data.item.itemNm : '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.costItems, 'itemCd'),
      cellEditorParams: (param) => {return {items: this.pageComp.costItemAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 250
    },
    { 
      headerName: '통화',
      field: 'crncyCd',
      editable: false,
      cellEditor: "crncyEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.currencyAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 100
    },
    { headerName: '출발지',
      children: [
      {
        headerName: 'CBM',
        field: 'orgCbmCost',
        width: 100,
        editable: false,
        cellEditor: "orgCbmEditor",
        filter:'agNumberColumnFilter'
      },
      {
        headerName: 'B/L',
        field: 'orgBlCost',
        width: 100,
        editable: false,
        cellEditor: "orgBlEditor",
        filter:'agNumberColumnFilter'
      }]
    },
    { headerName: '도착지',
      children: [
        {
          headerName: 'CBM',
          field: 'desCbmCost',
          width: 100,
          editable: false,
          cellEditor: "desCbmEditor",
          filter:'agNumberColumnFilter'
        },
        {
          headerName: 'B/L',
          field: 'desBlCost',
          width: 100,
          editable: false,
          cellEditor: "desBlEditor",
          filter:'agNumberColumnFilter'
        }]
    },
    {
      headerName: '저장일시',
      field: 'orgInsDtm',
      editable: false,
      valueGetter: params => params.data.orgInsDtm ? params.data.orgInsDtm : params.data.desInsDtm,
      cellRenderer: params => {
        var date = Util.dateFomatter(params.value);
        return date;
      },
      width: 200
    }
  ];

  frameworkCompsLclIncid = {
    locationEditor: AgAutoCompleteEditor,
    costItemEditor: AgAutoCompleteEditor,
    crncyEditor: AgAutoCompleteEditor,
    orgCbmEditor: AgNumericEditor,
    orgBlEditor: AgNumericEditor,
    desCbmEditor: AgNumericEditor,
    desBlEditor: AgNumericEditor,
    activityYnRenderer : AgCheckboxComponent,
  };

  colDefAirIncid = [
    { headerName: '오픈상태',
      field: 'activityYn',
      editable: false,
      cellRenderer: 'activityYnRenderer',
      width: 100
    },
    { headerName: '포트', field: 'location',
      cellEditor: "locationEditor",
      editable: false,
      valueGetter: params => params.data.location && params.data.location.locationCd ? '[' + params.data.location.locationCd + '] ' + params.data.location.name: '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.ports, 'locationCd'),
      cellEditorParams: (param) => {return {items: this.pageComp.getPortItemListByCntry(this.pageComp.selectedCountry)};},
      filter: "agTextColumnFilter",
      width: 160,
    },
    {
      headerName: '운임항목', field: 'item',
      cellEditor: "costItemEditor",
      editable: false,
      valueGetter: params => params.data.item && params.data.item.itemCd ? '[' + params.data.item.itemCd + '] ' + params.data.item.itemNm : '',
      valueSetter: params => AgValueSetter.valueSetter(params, this.pageComp.costItems, 'itemCd'),
      cellEditorParams: (param) => {return {items: this.pageComp.costItemAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 250
    },
    { 
      headerName: '통화',
      field: 'crncyCd',
      editable: false,
      cellEditor: "crncyEditor",
      cellEditorParams: (param) => {return {items: this.pageComp.currencyAutoCompleteItemList};},
      filter: "agTextColumnFilter",
      width: 100
    },
    { headerName: '출발지',
      children: [
      {
        headerName: 'KG',
        field: 'orgKgCost',
        width: 100,
        editable: false,
        cellEditor: "orgKgEditor",
        filter:'agNumberColumnFilter'
      },
      {
        headerName: 'AWB',
        field: 'orgAwbCost',
        width: 100,
        editable: false,
        cellEditor: "orgAwbEditor",
        filter:'agNumberColumnFilter'
      }]
    },
    { headerName: '도착지',
      children: [
        {
          headerName: 'KG',
          field: 'desKgCost',
          width: 100,
          editable: false,
          cellEditor: "desKgEditor",
          filter:'agNumberColumnFilter'
        },
        {
          headerName: 'AWB',
          field: 'desAwbCost',
          width: 100,
          editable: false,
          cellEditor: "desAwbEditor",
          filter:'agNumberColumnFilter'
        }]
    },
    {
      headerName: '저장일시',
      field: 'orgInsDtm',
      editable: false,
      valueGetter: params => params.data.orgInsDtm ? params.data.orgInsDtm : params.data.desInsDtm,
      cellRenderer: params => {
        var date = Util.dateFomatter(params.value);
        return date;
      },
      width: 200
    }
  ];

  frameworkCompsAirIncid = {
    locationEditor: AgAutoCompleteEditor,
    costItemEditor: AgAutoCompleteEditor,
    crncyEditor: AgAutoCompleteEditor,
    orgKgEditor: AgNumericEditor,
    orgAwbEditor: AgNumericEditor,
    desKgEditor: AgNumericEditor,
    desAwbEditor: AgNumericEditor,
    activityYnRenderer : AgCheckboxComponent,
  };

  
}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr-fare/fwdr-fare-management-grid-incid.ts